import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Optional,
  Injectable,
  ChangeDetectorRef,
} from '@angular/core';
import { GSBaseControl } from './gs.base.control';
import { FormDropdownProperty } from '../entity/form/formDropdown.property';
import { Item } from '../entity/entities';

@Component({
  selector: 'gs-dropdown',
  templateUrl: './gs.dropdown.control.html',
})
@Injectable()
export class GSDropdownControl
  extends GSBaseControl
  implements OnInit, OnDestroy
{
  @Input() placeholder: string;
  //#region -------Properties

  get options() {
    return this.property.options;
  }
  //#endregion

  //#region -------Constructor
  constructor(
    @Optional() prop: FormDropdownProperty,
    @Optional() item: Item,
    private changeDr: ChangeDetectorRef
  ) {
    super(changeDr);
    this.property = prop;
    this.item = item;
  }
  //#endregion

  //#region -------NG Eents
  ngOnInit() {}

  ngOnDestroy() {}
  //#endregion

  //#region -------UI Events

  change(e) {
    if (e) {
      let previousValue = this.data[this.name];
      this.value = e.value;
      this.item.reCheckDirty();
      this.onChange.emit({
        propertyName: this.name,
        previousValue: previousValue,
        newValue: this.value,
        event: e,
        item: this.item,
        property: this.property,
      });
      this.property.changed.emit({
        propertyName: this.name,
        previousValue: previousValue,
        newValue: this.value,
        event: e,
        item: this.item,
        property: this.property,
      });
    }
  }

  keydown(e) {
    this.property?.keydown?.emit({ propertyName: this.name, event: e });
    var charCode = e.which || e.keyCode;
    //tab
    if (charCode == 9) {
      let previousValue = this.data[this.name];
      this.onChange.emit({
        propertyName: this.name,
        previousValue: previousValue,
        newValue: this.value,
        event: e,
        item: this.item,
        property: this.property,
      });
      this.property.changed.emit({
        propertyName: this.name,
        previousValue: previousValue,
        newValue: this.value,
        event: e,
        item: this.item,
        property: this.property,
      });
    }
  }

  //#endregion

  //#region -------Private
  //#endregion
}
